import React, { useState, useEffect, useContext } from "react";
import axios from 'axios'

import { GlobalContext, HOST } from "./context/GlobalContext"

import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import Table from 'react-bootstrap/Table'
import Form from 'react-bootstrap/Form'
import FloatingLabel from 'react-bootstrap/FloatingLabel'
import Offcanvas from 'react-bootstrap/Offcanvas'

import './App.css';
import { ArrowBarUp, CardList, Check, PencilFill, Wallet2, X } from "react-bootstrap-icons";

const ALMACEN_UPDATE_API = HOST + '/api/inv/almacen/update/'

const CURRENCY_FORMAT = new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' })
const DATE_FORMAT = new Intl.DateTimeFormat('es', { weekday: 'long', year: 'numeric', month: 'long', day: '2-digit', timeZone: (Intl.DateTimeFormat().resolvedOptions().timeZone) })

function Almacen() {
  const { setGlobalLoading, formDataToJson, setMailBody, setMailTitle, setShowMesage, getAlmacenes, almacenList, rol } = useContext(GlobalContext);

  const [ show, setShow ] = useState(false)
  const [ action, setAction ] = useState('Crear Proveedor')

  const [ idAlmacen, setIdAlmacen ] = useState({ })
  const [ almacen, setAlmacen ] = useState(null)

  useEffect(() => {
    setGlobalLoading( true )
    getAlmacenes()
  }, []);

  const showForm = (item) => {

    if( item ){
      setAction('Actualizar Almacén')
      setIdAlmacen(item.idAlmacen)
      setAlmacen(item.almacen)
    } else {
      setAction('Nuevo Almacén')
      setIdAlmacen(null)
      setAlmacen(null)
    }

    setShow(true)
  }

  const updateItem = (e) => {
    e.preventDefault();
    setGlobalLoading( true )
    var form = document.getElementById('almacenForm');
		var formData = new FormData(form);

    var json = formDataToJson(formData)

    console.log('json to update almacen', json)

    axios.post(ALMACEN_UPDATE_API, json, {
			headers: { 'content-type': 'application/json' }
    }).then(result => {
      console.log("result update", result.data)
      getAlmacenes()
      setShow(false)
      setGlobalLoading( false )
    })
    .catch(error => {
      console.log("error", error.message)
      setShowMesage(true)
      setMailTitle('Error')
      setMailBody('Ocurrió un error al guardar tu registro. Por favor intentalo mas tarde.')
      setGlobalLoading( false )
    })
  }

  return (
    <>
      <Offcanvas show={show} onHide={ () => setShow(false) } placement={'end'}>
        <Offcanvas.Header closeButton>
          <Offcanvas.Title>
            <div className="title-form">{ action }</div>
            <div className="desc-form"> Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. </div>
          </Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body>
          <Form id="almacenForm" onSubmit={ updateItem }>
            <Container>
              <Row>
                <div>
                  <input type="hidden" name="idAlmacen" value={ idAlmacen } />
                  <Container>
                    <Row>
                      <Col md="12">
                        <Form.Group className='mb-3'>
                          <FloatingLabel label="Almacén">
                            <Form.Control required name="almacen" value={ almacen } onChange={ (e) => setAlmacen( e.target.value ) } placeholder="" />
                          </FloatingLabel>
                        </Form.Group>
                      </Col>
                    </Row>
                  </Container>
                  
                  <br/>
                  <div align="center">
                    <button type="button" className="cancel-btn" onClick={ () => setShow(false) } >{ 'Cancelar' }</button>&nbsp;&nbsp;
                    <button type="submit" className="grl-btn">{ 'Guardar' }</button>
                  </div>
                </div>
              </Row>
            </Container>
          </Form>
        </Offcanvas.Body>
      </Offcanvas>

      <Container className='main-component'>
        <Row>
          <Col md={ 9 }>
            <div className="section-subtitle"> Lista de Almacenes </div>
            <br/>
          </Col>
          <Col md={ 3 } align="right">
            { parseInt(rol) === 2 && <div className="single-btn" onClick={ () => showForm() } > Nuevo </div> }
          </Col>
        </Row>
        <Row>
          <Col>
            <Table responsive>
              <thead>
                <tr>
                  <th>Almacén</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                { almacenList.length == 0 && 
                  <tr>
                    <td colSpan="6"> <div>Sin registros</div> </td>
                  </tr>
                }
                { almacenList.map( item => (
                  <tr key={ item.idAlmacen }>
                    <td> 
                      { item.almacen }
                    </td>
                    { parseInt(rol) === 2 &&
                      <td align="right"> 
                        <PencilFill onClick={ () => showForm(item) } className="table-icon" />
                      </td>
                    }
                  </tr>
                )) }
              </tbody>
            </Table>
          </Col>
        </Row>
      </Container>

    </>
  );
}

export default Almacen;
